export function openNewTab(url: string) {
  return window.open(url, '_blank');
}
